import { ReactNode } from 'react';

import { PageImpression } from '@spotify/plugin-confidence-tracking-react';

import { type PageDescriptor, useOptionalPageBridgeProps } from '../../utils';

export type PageImpressionWrapperProps = {
  descriptor: PageDescriptor;
  children: ReactNode;
};

export const PageImpressionWrapper = ({
  descriptor,
  children,
}: PageImpressionWrapperProps) => {
  const parentBridgeProps = useOptionalPageBridgeProps();
  const shouldFireImpression =
    !parentBridgeProps || parentBridgeProps.descriptor.id !== descriptor.id;

  if (!shouldFireImpression) {
    return <>{children}</>;
  }

  return <PageImpression pageId={descriptor.id}>{children}</PageImpression>;
};
